import { Component, OnInit } from '@angular/core';
import { RequisitionExceptionDataService } from '../../data-services/requisitionException.service';
import { RequisitionDataService } from '../../data-services/requisition.service';
import { LazyLoadEvent } from 'primeng/api';
import { SelectItem, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { HasClaimDirective } from '../../security/has-claim.directive';

@Component({
   selector: 'app-requisitionException-list',
  templateUrl: './requisitionException.list.html',
  providers: [MessageService],
  imports: [Toast, CommonModule, TableModule, HasClaimDirective]
})
export class RequisitionExceptionListComponent implements OnInit {

  constructor(private requisitionExceptionDataService: RequisitionExceptionDataService,
    private requisitionDataService: RequisitionDataService,
    private messageService: MessageService,
    private router: Router) {
   }

   requisitionExceptions;
   statuses: SelectItem[] = [];
   facilities: SelectItem[] = [];
   testNames: SelectItem[] = [];
   totalRecords: number;
   cols: any[];
   loading: boolean;
  selectedStatus: SelectItem;
  showSpinner: boolean = false;
  editRequisitionModalVisible: boolean = false;

   ngOnInit() {

      this.cols = [
        { field: 'Accession', header: 'Accession' },
        { field: 'ClientName', header: 'Client' },
        { field: 'IssueDescription', header: 'Issue Description' },
        { field: 'AssignedTo', header: 'Assigned To' },
        { field: 'AssignedDate', header: 'Assigned Date' },
        { field: 'ResolutionDescription', header: 'Resolution Description' },
        { field: 'Resolved', header: 'Resolved' },
        { field: 'ResolvedBy', header: 'Resolved By' },
        { field: 'ResolvedDate', header: 'Resolved Date' }//,
        //{ field: 'UpdatedBy', header: 'Updated By' },
        //{ field: 'UpdatedDate', header: 'Updated Date' }
      ];
      this.loading = true;
   }

   public handleSearchKey(event, reqlist) {
      if (event.keyCode == 13) {
         reqlist.filterGlobal(event.target.value, 'contains');
         event.preventDefault();
      }
  }

  public onDateSelect(event, reqlist, fieldName) {
    reqlist.filter(this.formatDate(event.target.value), fieldName, 'equals')
  }

  formatDate(date) {
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (month < 10) {
      month = '0' + month;
    }

    if (day < 10) {
      day = '0' + day;
    }

    return date.getFullYear() + '-' + month + '-' + day;
  }

   public loadRequisitionExceptionsLazy(event: LazyLoadEvent) {
      this.loading = true;
      this.requisitionExceptionDataService.getList(event.first, event.rows, event.sortField, event.sortOrder, event.filters).subscribe((data: any) => {
         this.totalRecords = data.totalRows;
         this.requisitionExceptions = data.rows;
         this.loading = false;
      });
  }

  public editRequisitionException(id) {
    //this.router.navigateByUrl('/add-requisitionException', { state: { id: id } });
    this.router.navigate(['/add-requisitionException', { state: { Id: id } }]); 
  }

  public editRequisition(accession, index) {
    this.editRequisitionModalVisible = true;
  }

  public dismissRequisitionException(accession, requisitionExceptionId) {
    this.showSpinner = true;
    this.requisitionExceptionDataService.DismissRequisitionException(requisitionExceptionId).subscribe((data: any) => {
      var index = this.requisitionExceptions.findIndex(obj => obj.Id == requisitionExceptionId);
      this.requisitionExceptions[index] = data;
      this.messageService.add({ severity: 'success', summary: 'Exception Dismissed', detail: `Accession [${accession}]` });
      this.showSpinner = false;
    },
      (err) => {
        this.messageService.add({ severity: 'error', summary: 'Exception Dismissed', detail: 'Unable to Dismiss Exception: ' + err.status });
        this.showSpinner = false;
      });
  }

  public attemptToResolveRequisitionExceptions(accession, requisitionExceptionId) {
    this.showSpinner = true;
    this.requisitionDataService.attemptToResolveRequisitionExceptions(accession).subscribe((data: any) => {
      var index = this.requisitionExceptions.findIndex(obj => obj.Id == requisitionExceptionId);
      this.requisitionExceptions[index] = data;
      this.messageService.add({ severity: 'success', summary: 'Attempt to Resolve Requisition Exceptions', detail: `Accession [${accession}]` });
      this.showSpinner = false;
    },
      (err) => {
        this.messageService.add({ severity: 'error', summary: 'Attempt to Resolve Requisition Exceptions', detail: 'Error: ' + err.status });
        this.showSpinner = false;
      });
  }

  public rejectRequisition(accession, requisitionExceptionId) {
    this.showSpinner = true;
    this.requisitionDataService.rejectRequisition(accession, 1, "").subscribe((data: any) => {
      var index = this.requisitionExceptions.findIndex(obj => obj.Id == requisitionExceptionId);
      this.requisitionExceptions[index] = data;
      this.messageService.add({ severity: 'success', summary: 'Reject Requisition', detail: `Accession [${accession}]` });
      this.showSpinner = false;
    },
      (err) => {
        this.messageService.add({ severity: 'error', summary: 'Reject Requisition', detail: 'Error: ' + err.status });
        this.showSpinner = false;
      });
  }

  public removeToast() {
    this.messageService.clear();
  }
}
